/**
 * GiftingGuard Component
 * ======================
 * Redirects to /gifts page when FEATURES.gifting is disabled.
 * Wraps gift-related routes to prevent access.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { FEATURES } from '../config/featureFlags';

const GiftingGuard = ({ children }) => {
  if (!FEATURES.gifting) {
    return <Navigate to="/gifts" replace />;
  }
  
  return children;
};

export default GiftingGuard;
